// Copyright (c) 2016 Deere & Company

import {combineReducers} from 'redux';
import cscRoutingInfo from './csc-user-routing-info';
import entitlements from './entitlements';
import {getCombinedReducers as getCombinedPreferencesReducers} from './preferences';
import security from './security';
import territories from './territories';
import user from './user';

export const getCombinedReducers = () => combineReducers({
    cscRoutingInfo,
    details: user,
    entitlements,
    preferences: getCombinedPreferencesReducers(),
    security,
    territories
});



// WEBPACK FOOTER //
// ./src/user/shared/reducers/index.js